module.exports = "data:image/gif;base64,R0lGODlhPABDAJEAAAAAAP///27H0f///yH5BAEAAAMALAAAAAA8AEMAAALonI+pKe29opyUveuq3gr7zIXUR0LiiZQqiqouG7ovrMkyXdkzLuk7b/GVgAvhihg0epBJJYZ5cJKgBumSOrA+sdoLNtsFccPfKrkMtqKj6nVa6WYb480f3Wy/18X6vr8cdsUTOERDeNRyiBijmJfTuFgD6dgzGTliWbiRqSnJKej56cUhCvpY+sCIyne6KqC69eYjFxs6KmuT8gF7C0d7a5uKN/srvLk7rKNriinom2wcLPaMy9ocSz1Filz9o33sPFdsPfGdzS1t0r34nf4KfTOu7i7Pjt7aKw4/v+zq/w8woMCBBAUUAAA7"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_01.gif
// module id = Fg2q
// module chunks = 1